<template>
  <div>
    <el-table :data="auditList" style="width: 100%" height="calc(100vh - 353px)"
      @selection-change="handleSelectionChange">
      <el-table-column v-if="activeTab == '1'" type="selection" width="55">
      </el-table-column>
      <el-table-column label="用户ID" fixed>
        <template slot-scope="scope">
          <a :class="scope.row.mark ? 'red' : 'account-link'" @click="showBox(scope.row, 2)">
            {{ scope.row.userId }}
          </a>
        </template>
      </el-table-column>
      <el-table-column prop="realName" label="姓名"> </el-table-column>
      <el-table-column prop="id" label="订单号" width="120" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="txFee" label="手续费"> </el-table-column>
      <el-table-column prop="minerFee" label="矿工费">
        <template slot-scope="scope">
          {{ scope.row.minerFee }}
        </template>
      </el-table-column>
      <el-table-column prop="actualAmount" label="实际到账"> </el-table-column>
      <!-- </el-table-column> -->
      <!-- <el-table-column prop="minerFeeCoin" label="矿工费币种" width="100"> </el-table-column> -->
      <el-table-column min-width="60" label="时间" width="100">
        <template slot-scope="scope">
          {{ scope.row.createdTime | moment }}
        </template>
      </el-table-column>
      <el-table-column width="120" label="是否异常账号" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.mark" class="red">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column prop="txCoin" label="币种"> </el-table-column>
      <el-table-column prop="chain" label="币种链"> </el-table-column>
      <el-table-column prop="txType" label="提现类型">
        <template slot-scope="scope">
          <span v-if="scope.row.txType === -1">提现</span>
          <span v-else-if="scope.row.txType === -2 && scope.row.remark === 'internal'">内部转入</span>
          <span v-else>内部转出</span>
        </template>
      </el-table-column>
      <el-table-column prop="txAmount" label="提现数量"> </el-table-column>
      <el-table-column label="提现地址" min-width="150" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <a :href="scope.row.txNetworkLink" target="_blank" class="network-link">
            {{ scope.row.txToWallet }}
          </a>
        </template>
      </el-table-column>
      <el-table-column label="hash" width="220" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <a :href="scope.row.txHash" target="_blank" class="network-link">
            {{ scope.row.txHash }}
          </a>
        </template>
      </el-table-column>
      <el-table-column prop="txStatus" label="状态" width="240">
        <template slot-scope="scope">
          <el-tag :type="scope.row.__status.color" v-if="scope.row.status !== 2">
            {{ scope.row.__status.text }}
          </el-tag>
          <span v-if="scope.row.status === 2" class="text-disabled">
            {{ scope.row__status.text }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="txStatusInner" label="内部状态" width="200">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.txStatusInner == 'FAIL_CANNOT_RETRY'">失败不能重试</el-tag>
          <el-tag v-else-if="scope.row.txStatusInner == 'EXECUTING_WITHDRAW'">正在执行中</el-tag>
          <el-tag type="danger" v-else-if="scope.row.txStatusInner == 'FAIL'">失败</el-tag>
          <el-tag type="warning" v-else-if="scope.row.txStatusInner == 'HOT_NOT_ENOUGH_MONEY'">热钱包余额不足</el-tag>
          <el-tag type="warning" v-else-if="scope.row.txStatusInner == 'VALIDATE_ARGUMENT_FAIL'">加密校验不通过</el-tag>
          <el-tag v-else-if="scope.row.txStatusInner == 'INIT'">初始化，可以进行转账</el-tag>
          <el-tag type="warning" v-else-if="scope.row.txStatusInner == 'REPEAT'">重试</el-tag>
          <el-tag type="success" v-else-if="scope.row.txStatusInner == 'SUCCESS'">成功</el-tag>
          <el-tag type="warning" v-else-if="scope.row.txStatusInner == 'DUPLICATE_TO_ADDRESS'">重复提现目标地址</el-tag>
          <el-tag type="warning" v-else-if="scope.row.txStatusInner == 'NOT_EXISTED_TO_ADDRESS'">目标地址错误或者不存在</el-tag>
          <el-tag type="warning" v-else-if="
            scope.row.txStatusInner == 'TRANSACTION_HASH_RETURN_NULL'
          ">返回Tx hash值为空</el-tag>
          <el-tag type="danger" v-else-if="scope.row.txStatusInner == 'SIGN_ERROR'">Sign失败</el-tag>
          <el-tag type="danger" v-else-if="scope.row.txStatusInner == 'SUBMIT_ERROR'">Submit失败</el-tag>
          <el-tag type="danger" v-else-if="scope.row.txStatusInner == 'VERIFY_ERROR'">Verify失败</el-tag>
          <el-tag v-else-if="scope.row.txStatusInner == 'EXECUTING_DISPOSE'">正在执行中</el-tag>
          <el-tag v-else-if="scope.row.txStatusInner == 'REPEAT_CANNOT_RETRY'">重复不能重试</el-tag>
          <el-tag v-else-if="scope.row.txStatusInner == 'BALANCE_NOT_ENOUGH'">变更余额不足</el-tag>
          <el-tag v-else-if="scope.row.txStatusInner == 'WAITING_FOR_CONFIRMATION'">等待确认中</el-tag>
          <el-tag type="danger" v-else-if="scope.row.txStatusInner == 'UNSUPPORTED_TRANSACTION'">不支持此交易</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" show-overflow-tooltip label="备注">
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="160" align="center">
        <template slot-scope="scope">
          <el-tooltip content="重试" v-if="
            (scope.row.txStatus === 4 &&
              retryableStatus.includes(scope.row.txStatusInner)) ||
            scope.row.txStatus === 5
          ">
            <el-button size="small" circle icon="el-icon-refresh" @click="retryWithdrawal(scope.row)">
            </el-button>
          </el-tooltip>
          <!-- <el-tooltip
            content="重试"
            v-if="
              (scope.row.txStatus === 4 &&
                retryableStatus.includes(scope.row.txStatusInner)) ||
                (scope.row.txCoin === 'EOS' && scope.row.txStatus === 5)
            "
          >
            <el-button
              size="small"
              circle
              icon="el-icon-refresh"
              @click="retryWithdrawal(scope.row)"
            >
            </el-button>
          </el-tooltip> -->
          <el-tooltip content="审核通过" v-if="scope.row.txStatus === 1">
            <el-button type="success" @click="approveAudit(scope.row)" icon="el-icon-success" size="small" circle>
            </el-button>
          </el-tooltip>
          <el-tooltip content="置为异常" v-if="[1, 4].includes(scope.row.txStatus)">
            <el-button type="danger" @click="freezeAudit(scope.row)" size="small" icon="el-icon-warning" circle>
            </el-button>
          </el-tooltip>
          <el-tooltip content="撤销" v-if="scope.row.txStatus === 1 || scope.row.txStatus === 6">
            <el-button @click="cancelAudit(scope.row)" size="small" circle icon="el-icon-back">
            </el-button>
          </el-tooltip>
          <el-tooltip content="发起提现" v-if="scope.row.txStatus === 4">
            <el-button @click="showSendDialog(scope.row.id)" size="small" type="success" icon="el-icon-check" circle>
            </el-button>
          </el-tooltip>
          <el-tooltip content="手动转账确认成功" v-if="scope.row.txStatus === 5">
            <el-button type="success" @click="handleManualConfirm(scope.row.id)" icon="el-icon-success" size="small"
              circle>
            </el-button>
          </el-tooltip>
          <el-tooltip content="退回未审核" v-if="scope.row.txStatus === 5 && userInfo.roleId === 1">
            <el-button @click="handleReturnToNotApproved(scope.row.id, scope.row.email)" icon="el-icon-back"
              size="small" circle>
            </el-button>
          </el-tooltip>
          <el-tooltip content="置为区块已发送" v-if="scope.row.txStatus === 4">
            <el-button @click="handleSentConfirmed(scope.row)" icon="el-icon-s-promotion" size="small" circle>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="pager-wrap" style="text-align: right; margin: 10px 0px">
      <pagination :size="pagination.size" :page="pagination.page" :total="audistCount"
        @pageChanged="handleCurrentChange">
      </pagination>
    </div>
    <div class="user-withdrawal-records-wrap">
      <el-dialog :visible.sync="showUserDialog" title="账户余额信息" width="1200px">
        <withdraw-records v-if="showUserDialog" :uid="nowUserId" :emails="emails"></withdraw-records>
      </el-dialog>
    </div>
    <div class="send-trans-dialog">
      <el-dialog :visible.sync="ifShowSendDialog" @close="closeSendDialog" width="800px">
        <el-form :model="sendTransForm" ref="sendTransForm" label-width="100px">
          <el-form-item prop="transId" label="网络ID" :rules="[{ required: true, message: '请输入网路ID' }]">
            <el-input v-model="sendTransForm.transId"></el-input>
          </el-form-item>
          <el-form-item prop="googleCode" label="谷歌验证码" :rules="[{ required: true, message: '请输入谷歌验证码' }]">
            <el-input v-model="sendTransForm.googleCode"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="sendTransNow()">确定提交</el-button>
            <el-button @click="closeSendDialog()">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
    <!-- 谷歌验证 -->
    <el-dialog :title="title" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <!-- <el-form-item label="备注信息">
          <el-input v-model="form.remark"></el-input>
        </el-form-item> -->
        <el-form-item label="谷歌验证码" prop="googleCode">
          <el-input v-model="form.googleCode"></el-input>
        </el-form-item>
        <!-- <el-form-item label="证码密码" prop="pwd">
          <el-input v-model="form.pwd"></el-input>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 重试区块dialog -->
    <el-dialog :title="title1" :visible.sync="retryDialogVisible" width="25%" :before-close="handleClose">
      <el-form ref="retryForm" :model="retryForm" :rules="rules" label-width="120px">
        <el-form-item label="gasPrice" prop="gasPrice">
          <el-input v-model="retryForm.gasPrice"></el-input>
        </el-form-item>
        <el-form-item label="gasLimit" prop="gasLimit">
          <el-input v-model="retryForm.gasLimit"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="retryDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="retrySubmit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 置为区块dialog -->
    <el-dialog title="置为区块发送验证" :visible.sync="blockDialogVisible" width="25%" :before-close="handleClose">
      <el-form ref="blockForm" :model="blockForm" :rules="rules" label-width="120px">
        <el-form-item label="txHash" prop="txHash">
          <el-input v-model="blockForm.txHash"></el-input>
        </el-form-item>
        <el-form-item label="googleCode" prop="googleCode">
          <el-input v-model="blockForm.googleCode"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="blockDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="blockSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <UserDetailDialog :id="id" :type="type" />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import WithdrawRecords from '../records'
import Pagination from 'components/pagination'
import UserDetailDialog from 'components/userDetailDialog'

export default {
  name: 'AuditList',
  props: ['activeTab'],
  data() {
    return {
      blockId: '',
      title: '',
      title1: '',
      retryId: '',
      form: {},
      retryForm: {},
      dialogVisible: false,
      retryDialogVisible: false,
      showUserDialog: false,
      ifShowSendDialog: false,
      blockDialogVisible: false,
      nowUserId: '',
      emails: '',
      sendOrderId: '',
      detail: {},
      blockForm: {},
      sendTransForm: {
        id: '',
      },
      retryableStatus: [
        'FAIL_CANNOT_RETRY',
        'EXECUTING_WITHDRAW',
        'HOT_NOT_ENOUGH_MONEY',
        'DUPLICATE_TO_ADDRESS',
      ],
      rules: {
        googleCode: [
          { required: true, message: '请填写谷歌验证码', trigger: blur },
        ],
        txHash: [{ required: true, message: '请输入TxHash', trigger: blur }],
        gasLimit: [
          { required: true, message: '请填写gasLimit', trigger: blur },
        ],
        gasPrice: [
          { required: true, message: '请填写gasPrice', trigger: blur },
        ],
        //: [{ required: true, message: '请填写验证密码', trigger: blur }],
      },
      type: '',
      id: '',
    }
  },
  computed: {
    ...mapState('withdrawalAudit', [
      'auditList',
      'allCoins',
      'audistCount',
      'pagination',
    ]),
    ...mapState(['userInfo']),
    ...mapMutations('withdrawalAudit', ['setIdStr']),
  },
  methods: {
    ...mapActions('withdrawalAudit', [
      'approve',
      'retry',
      'resetUserRecords',
      'setAuditToErr',
      'cancel',
      'updateFreeze',
      'sendWithdrawalTrans',
      'remark',
      'manualConfirm',
      'returnToNotApproved',
      'sentConfirmed',
    ]),

    ...mapMutations('contractassets', ['setUserDetailInfoVisible']),
    showBox(row, type) {
      this.type = type
      this.id = row.userId
      this.setUserDetailInfoVisible(true)
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => { })
    },
    showPrompt(content, audit, callback) {
      // console.log('audit',audit);

      return this.$prompt(content, '提示', {
        inputPlaceholder: '备注信息',
        inputValue: audit.remark,
      }).then(({ value }) => {
        // console.log('value',value);

        return callback()
          .then(() => {
            return value !== audit.remark
              ? this.remark({ id: audit.id, remark: value })
              : Promise.resolve() //如果值未修改则不请求
          })
          .then(() => {
            this.$message({
              message: '操作成功！',
              type: 'success',
            })
            this.refreshList()
          })
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val.map((item) => item.id).join()
      this.$store.commit('withdrawalAudit/setIdStr', this.multipleSelection)
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.approve({
            id: this.detail.id,
            googleCode: this.form.googleCode,
            //pwd: this.form.pwd,
          }).then((res) => {
            if (res.code == 0) {
              this.dialogVisible = false
              this.form = {}
              this.$message({
                message: '操作成功！',
                type: 'success',
              })
              this.refreshList()
              this.$refs.form.resetFields()
            }
          })
        }
      })
    },
    retrySubmit() {
      this.$refs.retryForm.validate((valid) => {
        if (valid) {
          this.retry({
            id: this.retryId,
            gasLimit: this.retryForm.gasLimit,
            gasPrice: this.retryForm.gasPrice,
          }).then((res) => {
            if (res.code == 0) {
              this.retryDialogVisible = false
              this.retryForm = {}
              this.$message({
                message: '操作成功！',
                type: 'success',
              })
              this.refreshList()
              this.$refs.retryForm.resetFields()
            }
          })
        }
      })
    },
    approveAudit(audit) {
      this.dialogVisible = true
      this.title = '确认通过审核吗？'
      this.detail = { ...audit }

      // this.handleApprove('form','确认通过审核吗？',audit,()=>this.approve(audit.id))
      // this.showPrompt('确认通过审核吗？', audit, () => this.approve(audit.id));
    },
    freezeAudit(audit) {
      this.showPrompt('确认要置为异常吗？', audit, () =>
        this.updateFreeze(audit.id)
      )
    },
    cancelAudit(audit) {
      this.showPrompt('确认要撤销吗？', audit, () => this.cancel(audit.id))
    },
    retryWithdrawal(audit) {
      // console.log('retry-audit',audit);
      this.retryId = audit.id
      this.retryDialogVisible = true
      this.title1 =
        '重试前，请确认该提现地址在区块链浏览器上没有此平台的转账记录。'
      // this.showPrompt(
      //   '重试前，请确认该提现地址在区块链浏览器上没有此平台的转账记录。',
      //   audit,
      //   () => this.retry(audit.id)
      // );
    },
    setAuditError(audit) {
      this.showPrompt('确认将该记录置为异常？', audit, () =>
        this.setAuditToErr(audit.id)
      )
    },
    getUserDetail(uid, email) {
      this.nowUserId = uid
      this.emails = email
      this.showUserDialog = true
    },
    refreshList() {
      this.handleCurrentChange({
        page: 1,
      })
    },
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination)
    },
    showSendDialog(id) {
      this.sendOrderId = id
      this.ifShowSendDialog = true
    },
    sendTransNow() {
      this.$refs['sendTransForm'].validate((valid) => {
        if (valid) {
          this.sendWithdrawalTrans({
            id: this.sendOrderId,
            transId: this.sendTransForm.transId,
            googleCode: this.sendTransForm.googleCode,
          }).then(() => {
            this.closeSendDialog()
            this.$message({
              message: '操作成功！',
              type: 'success',
            })
            this.refreshList()
          })
        }
      })
    },
    closeSendDialog() {
      this.$refs['sendTransForm'] && this.$refs['sendTransForm'].resetFields()
      this.ifShowSendDialog = false
    },
    handleManualConfirm(txId) {
      this.$confirm('确认手动转账已成功吗？', '提示', {
        type: 'warning',
      }).then(() => {
        this.manualConfirm(txId).then(() => {
          this.$message.success('操作成功！')
          this.refreshList()
        })
      })
    },
    handleReturnToNotApproved(txId) {
      this.$confirm('确认退回未审核状态吗？', '提示', {
        type: 'warning',
      }).then(() => {
        this.returnToNotApproved(txId).then(() => {
          this.$message.success('操作成功！')
          this.refreshList()
        })
      })
    },
    blockSubmit() {
      console.log('audit', this.blockId)
      this.$refs.blockForm.validate((valid) => {
        if (valid) {
          this.sentConfirmed({
            id: this.blockId,
            txHash: this.blockForm.txHash,
            googleCode: this.blockForm.googleCode,
          }).then((res) => {
            if (res.code == 0) {
              this.blockDialogVisible = false
              this.$message.success('操作成功！')
              this.refreshList()
              this.$refs.blockForm.resetFields()
            }
          })
        }
      })
    },
    handleSentConfirmed(audit) {
      this.blockId = audit.id
      this.blockDialogVisible = true

      // this.$prompt('请输入TxHash', '提示', {
      //   inputValidator: value =>
      //     value !== null && value !== '' && value !== undefined
      // }).then(({ value }) => {
      //   this.sentConfirmed({ id: audit.id, txHash: value }).then(() => {
      //     this.$message.success('操作成功！');
      //     this.refreshList();
      //   });
      // });
    },
  },
  components: {
    WithdrawRecords,
    Pagination,
    UserDetailDialog,
  },
}
</script>

<style lang="less" scoped>
@import url('~styles/variables.less');

.account-link,
.network-link {
  color: @color-primary;

  &:hover {
    text-decoration: underline;
  }
}

.red {
  color: red;
  font-weight: bold;
}
</style>
